/* eslint react/no-unescaped-entities: "off" */
import React, { FC, ReactElement } from 'react'
import { MarkAsReadBulkContentProps, NotificationSourceFilterValues } from '../types'
import { Snapdocs } from '../../../../hooks/api/snapdocs'
import { Requests } from '../../../../api/requests'
import { get } from 'lodash'
import MESSAGES from './MarkAsReadBulk.messages'

export const MarkAsReadBulkContent: FC<MarkAsReadBulkContentProps> = ({ unreadCount, owner, source }): ReactElement => {
  const { request, response: appConfig } = Snapdocs.useResources(Requests.appConfig())

  const name = (owner: string) => {
    if (owner === 'mine') {
      return get(appConfig, ['currentUser', 'fullName'])
    }
    return get(appConfig, ['currentCompany', 'name'])
  }

  const getDescriptionMessage = () => {
    if (source === NotificationSourceFilterValues.AUTO_PINNER) {
      return owner === 'mine'
        ? MESSAGES.CONFIRM_PROMPT.AUTO_PINNED_ORDER_OWNER_DESCRIPTION
        : MESSAGES.CONFIRM_PROMPT.AUTO_PINNED_COMPANY_DESCRIPTION
    } else if (source === NotificationSourceFilterValues.NOT_AUTO_PINNER) {
      return owner === 'mine'
        ? MESSAGES.CONFIRM_PROMPT.NOT_AUTO_PINNED_ORDER_OWNER_DESCRIPTION
        : MESSAGES.CONFIRM_PROMPT.NOT_AUTO_PINNED_COMPANY_DESCRIPTION
    } else {
      return owner === 'mine'
        ? MESSAGES.CONFIRM_PROMPT.ORDER_OWNER_DESCRIPTION
        : MESSAGES.CONFIRM_PROMPT.COMPANY_DESCRIPTION
    }
  }

  if (Requests.isLoading(request)) {
    return <></>
  }

  return (
    <div className="mark-as-read-bulk-container">
      <p className="title">
        Mark
        <strong>
          {' '}
          all {unreadCount} of {name(owner)}'s{' '}
        </strong>
        notifications as read?
      </p>
      <p>{getDescriptionMessage()}</p>
    </div>
  )
}
